import React, { useEffect, useState } from 'react';
import axiosClient from '../../../../axios-client';
import icGenCard from '../../../assets/svg/steps/card/ic-gen-card.svg';

const Mapping = ({ csvData, idLang, templateSelected, updateFormData, onJsonDataReceived, contactLengh }) => {
  const [template, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTemplateVariables, setSelectedTemplateVariables] = useState([]);
  const [selectedGlobalVariables, setSelectedGlobalVariables] = useState([]);
  const [inputValues, setInputValues] = useState({});
  const [selectVar, setSelectedVar] = useState({});

  const handleInputChange = (variableName, value) => {
    const data = {
      [variableName]: value,
    };

    setInputValues({
      ...inputValues,
      [variableName]: value,
    });

    updateFormData(data);
  };

  const handleSelectChange = async (variable, selectedValue) => {
    setSelectedVar({
      ...selectVar,
      [variable]: selectedValue,
    });
  };

  useEffect(() => {
    if (csvData.length > 0) {
      renderCSVData(csvData);
      contactLengh(csvData.length)
    }

  }, [csvData]);

  useEffect(() => {
    if (idLang) {
      fetchTemplates(idLang);
    }
  }, [idLang]);

  useEffect(() => {
    if (templateSelected) {
      const selectedTemplate = template.find((item) => item.id === templateSelected);
      if (selectedTemplate) {
        const variables = selectedTemplate.variables || [];
        const globalVariable = selectedTemplate.global_variables || [];
        setSelectedTemplateVariables(variables);

        setSelectedGlobalVariables(globalVariable);
      }
    }
  }, [templateSelected, template]);

  useEffect(() => {
    if (selectVar) {
      onJsonDataReceived(jsonArrayResult);
    }
  }, [selectVar])

  const fetchTemplates = (languageId) => {
    setLoading(true);
    axiosClient
      .get(`/templates?language_id=${languageId}&is_broadcast=1`)
      .then(({ data }) => {
        setLoading(false);
        setTemplates(data.data);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const renderCSVData = (data) => {
    return (
      <>
        {selectedTemplateVariables.map((variables, index) => (
          <div className="row mb-3 justify-content-center align-items-center" id={index} key={index}>
            <div className='col-md-5 px-0 justify-content-start align-items-center'>
              <div className='form-control border rounded-pill'>
                <p className='p-2 m-0 p-txt' key={index}>{variables.name} :</p>
              </div>
            </div>
            <div className='col-md-1 p-0 divider-dashed'></div>
            <div className='col-md-5 p-0'>
              <select onChange={(e) => handleSelectChange(variables.variable, e.target.value)} className='form-control form-select rounded-pill p-2 select-option' value={selectVar[variables.variable] || ''}>
                <option>Please select option</option>
                {Object.keys(data[0]).map((col, key) => (
                  <option key={key} id={key} value={col}>
                    {selectVar[variables.variable] == col
                      ? `${col} (Selected)`
                      : col}
                  </option>
                ))}
              </select>
            </div>
          </div>
        ))}
      </>
    );
  };

  const renderCSVDataToJsonArray = (data, selectedVariables, selectVar) => {
    const jsonArray = [];
    // Iterate through each row in the CSV data
    data.forEach((rowData) => {
      const jsonData = {};
      selectedVariables.forEach((variable) => {
        const variableName = variable.variable;

        // Use selectVar to get the selected variable name for the current variable
        const selectedVariableName = selectVar[variable.variable];

        // Use the selected variable name to access properties in rowData
        const selectedValue = rowData[selectedVariableName] || ''; // Get the value from the CSV data

        // Add the variableName as a key and selectedValue as its value to the jsonData object
        jsonData[variableName] = selectedValue;
      });

      jsonArray.push(jsonData); // Add the jsonData object to the array
    });

    return jsonArray;
  };

  const jsonArrayResult = renderCSVDataToJsonArray(csvData, selectedTemplateVariables, selectVar);

  // console.log('JSON Array Result:', jsonArrayResult);


  return (
    <div className='container my-5'>
      <div className='d-flex justify-content-center align-items-center'>
        <div className="col-md-10">
          {csvData.length > 0 && (
            <>
              {renderCSVData(csvData)}
            </>
          )}
        </div>
      </div>

      {
        selectedGlobalVariables.length > 0 ? <>
          <div id='content' className='divider my-5'></div>
          <img className='my-3 d-flex mx-auto ic-card-msg' src={icGenCard} alt='' srcSet='' />
          <h1 className='text-center title my-4'>Generic Information</h1>
          <div className='divider my-5'></div>
        </> : <div className='divider my-5'></div>
      }


      <div className='row justify-content-center align-items-center'>
        <div className='col-md-10 row mt-2  p-txt'>
          {selectedGlobalVariables.map((global_variables, index) => (
            <div className="col-md-6 my-3" key={index}>
              <label className='mb-3' htmlFor="">{global_variables.name}</label>
              <input
                required
                name={global_variables.variable}
                placeholder={global_variables.name}
                type="text"
                className='form-control rounded-pill'
                value={inputValues[global_variables.variable] || ''}
                onChange={(e) =>
                  handleInputChange(global_variables.variable, e.target.value)
                }
              />
              <span className={`${global_variables.variable} d-none text-danger`}>
                {global_variables.name} is required
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Mapping;
